import { SelectedFilterType } from '../types/filter.type'
import { AssetType } from '../types/bucketTypes'
import { MAKE, MANUFACTURER, MODEL } from '../constants/filter.constants'

export const onFilterAssets = (
    filter: SelectedFilterType[],
    assets?: AssetType[]
) => {
    if (assets == undefined) return []
    
    // If no filters are selected, return all assets
    if (filter.length === 0) return assets

    return assets.filter((asset: any) => {
        const {
            bucket: { make, model, manufacturer },
        } = asset

        // Check if asset matches ANY of the selected filters
        return filter.some((selectedFilter) => {
            const category = selectedFilter.category.toLowerCase()
            const title = selectedFilter.title
            const id = selectedFilter.id
            if (category === 'make') {
                if(id?.includes(category))
                    return make === title
            } else if (category === 'model') {
                if(id?.includes(category))
                    return model === title
            } else if (category === 'manufacturer') {
                if(id?.includes(category))
                    return manufacturer === title
            }
            return false
        })
    })
}

const getCheckedFilters = (filters: SelectedFilterType[]) => {
    //filter to only return object with true values, map to only return checked string instead of whole object data
    let makeFilters: string[] = []
    let modelFilters: string[] = []
    let manufacturerFilters: string[] = []

    filters.forEach((filter: SelectedFilterType) => {
        const category = filter.category.toLowerCase();
        if (category === MAKE.toLowerCase()) makeFilters.push(filter.title)
        if (category === MODEL.toLowerCase()) modelFilters.push(filter.title)
        if (category === MANUFACTURER.toLowerCase())
            manufacturerFilters.push(filter.title)
    })
    return {
        makeFilters,
        modelFilters,
        manufacturerFilters,
    }
}

const isEmpty = (array: Array<unknown>) =>
    array.length == 0 || array == undefined
